import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NotifierService } from 'angular-notifier';
import { from } from 'rxjs';

import { CarouselData } from '@core/models/carousel-data';
import { UserConfirmationComponent } from '../user-confirmation/user-confirmation.component';
import { PhotoService } from '@core/services/photo.service';
import { PhotoViewerComponent } from '../photo-viewer/photo-viewer.component';
import { UserService } from '@core/services/user.service';
import { User } from '@core/models/user';
import { FileConverterService } from '@core/services/file-converter.service';
import { config } from 'process';

@Component({
	selector: 'app-photo-upload',
	templateUrl: './photo-upload.component.html',
	styleUrls: ['./photo-upload.component.scss']
})
export class PhotoUploadComponent implements OnInit {

	overlayRef: OverlayRef;
	user: User;

	validExtensions: string[] = [ 'jpg', 'jpeg', 'png'];
	photoControl = new FormControl();

	constructor(
		private modalService: NgbModal,
		public photoService: PhotoService,
		private overlay: Overlay,
		private userService: UserService,
		private deviceService: DeviceDetectorService,
		private notifierService: NotifierService,
		private fileConverterService: FileConverterService) {

		this.user = userService.getUser();
	}

	ngOnInit(): void {
	}

	isMobileDevice() {

		return this.deviceService.isMobile() || this.deviceService.isTablet();
	}

	onFileSelect(fileList: FileList, addTimeStamp: boolean = false) {

		const photoList = from(fileList);
		photoList.subscribe(async file => {

			if (!this.fileIsValid(file)) {

				this.notifierService.notify('error', `De afbeelding '${file.name}' moet een .png, .jpg of .jpeg bestand zijn.`);
			}
			else {
				const carouselData = new CarouselData();
				carouselData.src = await this.readFile(file);
				carouselData.file = file;
				carouselData.id = this.photoService.photoCarousel.length + 1;
        carouselData.addTimeStamp = addTimeStamp;

				this.photoService.addPhoto(carouselData);
				this.photoControl.reset();
			}
		});
	}

	fileIsValid(file: File): boolean {

		const extension = file.name.split('.').pop();
		return this.validExtensions.some(ext => ext == extension);
	}

	showPhoto(carouselData: CarouselData) {

		this.overlayRef = this.overlay.create({
			hasBackdrop: true
		});

		const componentPortal = new ComponentPortal(PhotoViewerComponent);
		const componentRef = this.overlayRef.attach<PhotoViewerComponent>(componentPortal);

		componentRef.instance.carouselData = carouselData;
		componentRef.instance.closeOverlay.subscribe(async (base64) => {

			if (base64) {

				const imageBlob = this.fileConverterService.dataURItoBlob(base64);

				carouselData.file = new File([imageBlob], 'img.png');
				carouselData.src = base64;

				this.photoService.editPhoto(carouselData);
			}

			window.scrollTo(0, 0);
			this.overlayRef.detach();
		});
	}

	deletePhoto(carouselData: CarouselData) {

		const modalRef = this.modalService.open(UserConfirmationComponent, {
			windowClass: '',
			keyboard: false,
			backdrop: 'static',
			centered: true
		});

		let userConfirmationComponent = modalRef.componentInstance as UserConfirmationComponent;
		userConfirmationComponent.title = 'Foto verwijderen';
		userConfirmationComponent.bodyText = `Weet u zeker dat u deze foto wilt verwijderen?`;

		modalRef.result.then((confirmed: boolean) => {

			if (confirmed) {

				this.photoService.deletePhoto(carouselData.id);
			}

		}, () => { });
	}

	private readFile(file: File): Promise<string | ArrayBuffer> {

		return new Promise((resolve, reject) => {

			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {

				resolve(reader.result);
			};
			reader.onerror = () => {

				reject(reader.error);
			};
		});
	}
}
